import { Bookmark, Radio, SlidersHorizontal, Star, CalendarRange, Wine } from "lucide-react";

const WINE_EMAIL = "marchettipiermario@gmail.com";

const TABS = [
  { id: "standard", label: "Ricerca standard", Icon: SlidersHorizontal, activeColor: "text-white border-gold" },
  { id: "multiday", label: "Ricerca per più giorni", Icon: CalendarRange, activeColor: "text-gold border-gold" },
  { id: "pier4", label: "Ricerca Pier 4", Icon: Star, activeColor: "text-gold border-gold" },
  { id: "pier5", label: "Ricerca Pier 5", Icon: Star, activeColor: "text-gold border-gold" },
  { id: "pier6", label: "Ricerca Pier 6", Icon: Star, activeColor: "text-gold border-gold" },
  { id: "pier7", label: "Ricerca Pier 7", Icon: Star, activeColor: "text-gold border-gold" },
  { id: "pier8", label: "Ricerca Pier 8", Icon: Star, activeColor: "text-gold border-gold" },
  { id: "pickup_live", label: "Pickup Live", Icon: Radio, activeColor: "text-red-400 border-red-400" },
  { id: "coglione", label: "Coglione", Icon: Star, activeColor: "text-gold border-gold" },
  { id: "coglione2", label: "Coglione 2", Icon: Star, activeColor: "text-gold border-gold" },
  { id: "watchlist", label: "Sotto osservazione", Icon: Star, activeColor: "text-gold border-gold", withCount: true },
  { id: "wine", label: "Vini & Spirits", Icon: Wine, activeColor: "text-gold border-gold", wineOnly: true },
  { id: "saved", label: "Le mie ricerche", Icon: Bookmark, activeColor: "text-gold border-gold" },
];

export default function ModeTabs({ mode, onChange, user = null, watchlistCount = 0 }) {
  const visibleTabs = TABS.filter((t) => {
    if (t.id === "saved") return !!user;
    if (t.wineOnly) return user?.email === WINE_EMAIL;
    return true;
  });
  return (
    <div className="flex gap-1 mb-6 border-b border-white/10 flex-wrap" data-testid="mode-tabs">
      {visibleTabs.map(({ id, label, Icon, activeColor, withCount }) => {
        const active = mode === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            className={`flex items-center gap-2 px-5 py-3 text-xs uppercase tracking-[0.22em] transition-colors duration-200 border-b-2 -mb-px ${
              active ? activeColor : "text-white/40 border-transparent hover:text-white/70"
            }`}
            data-testid={`tab-${id}`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
            {withCount && watchlistCount > 0 && (
              <span className="ml-1 text-[10px] bg-gold/20 text-gold px-1.5 py-0.5 rounded-full leading-none">
                {watchlistCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}